
import { CompanyService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			results: [] as {companyId:number, targetDbId:number}[]
		};
	},
	methods: {
		async fetch(){
			this.results = await CompanyService.getQueuedCompanyDbMoves();
		},
		async removeQueuedMove(companyId:number){
			await CompanyService.unqueueMoveToOtherDb(companyId);
			await this.fetch();
		},
		openCompany(companyId:number){
			this.$router.push(`/companies/${companyId}/info`);
		}
	},
	async mounted(){
		await this.fetch();
	}
});
